(function () {
  'use strict';

  var updatePinnedStages = function () {};
  var scrollCallbacks = [];
  var scrollTicking = false;
  var homepageScroll = null;
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var layoutRefreshTicking = false;
  var lastLayoutWidth = window.innerWidth;
  var lastCommittedHeight = Math.round(window.innerHeight);
  var blanketAnimating = false;
  var animateBlanketScrollTo = null;
  var currentSectionIndex = 0;
  var BLANKET_TRANSITION_MS = 680;
  var BLANKET_TRANSITION_MS_MOBILE = 580;
  var MOBILE_LAYOUT_QUERY = '(max-width: 1023px), (hover: none), (pointer: coarse)';
  var DESKTOP_LAYOUT_QUERY = '(min-width: 1024px) and (hover: hover) and (pointer: fine)';
  var SIDEBAR_LAYOUT_CACHE_KEY = 'nostalgia-sidebar-layout';
  var SIDEBAR_NAV_LIST_SELECTOR =
    '.hero__nav-list, .story-page__nav-list, .chronicles-page__nav-list, .legal-page__nav-list, .collection-listing__sidebar .collection-nav__list, .product-page__sidebar .collection-nav__list';
  function scheduleHomepageLayoutRefresh() {
    var width = window.innerWidth;
    var height = getSectionHeight();

    if (isMobile() && width === lastLayoutWidth && Math.abs(height - lastCommittedHeight) < 96) {
      return;
    }

    lastLayoutWidth = width;
    lastCommittedHeight = height;
    setViewportHeight();
    applySidebarLayout();

    if (!homepageScroll) return;

    if (layoutRefreshTicking) return;

    layoutRefreshTicking = true;

    requestAnimationFrame(function () {
      layoutRefreshTicking = false;
      homepageScroll.refreshLayout();
    });
  }

  function isMobile() {
    return window.matchMedia(MOBILE_LAYOUT_QUERY).matches;
  }

  function isDesktopLayout() {
    return window.matchMedia(DESKTOP_LAYOUT_QUERY).matches;
  }

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function subscribeScroll(callback) {
    scrollCallbacks.push(callback);
  }

  function onGlobalScroll() {
    if (!scrollTicking) {
      scrollTicking = true;
      requestAnimationFrame(function () {
        scrollTicking = false;
        scrollCallbacks.forEach(function (callback) {
          callback();
        });
      });
    }
  }

  window.addEventListener('scroll', onGlobalScroll, { passive: true });

  function getScrollY() {
    return window.scrollY || document.documentElement.scrollTop || 0;
  }

  function getSectionHeight() {
    var height = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--viewport-height')
    );

    if (height > 0) {
      return Math.round(height);
    }

    return Math.round(window.innerHeight);
  }

  function setViewportHeight() {
    document.documentElement.style.setProperty(
      '--viewport-height',
      getSectionHeight() + 'px'
    );
  }

  function cacheSidebarLayout(heroTopOffset, sidebarNavHalfHeight) {
    if (!heroTopOffset || !sidebarNavHalfHeight) return;

    try {
      sessionStorage.setItem(
        SIDEBAR_LAYOUT_CACHE_KEY,
        JSON.stringify({
          heroTopOffset: heroTopOffset,
          sidebarNavHalfHeight: sidebarNavHalfHeight
        })
      );
    } catch (error) {}
  }

  function measureSidebarNavHalfHeight() {
    var navList = document.querySelector(SIDEBAR_NAV_LIST_SELECTOR);

    if (!navList) return null;

    var dropdowns = navList.querySelectorAll('[data-nav-dropdown]');
    var opened = [];
    var index;

    for (index = 0; index < dropdowns.length; index += 1) {
      if (dropdowns[index].open) {
        opened.push(dropdowns[index]);
        dropdowns[index].open = false;
      }
    }

    var height = Math.ceil(navList.getBoundingClientRect().height);

    for (index = 0; index < opened.length; index += 1) {
      opened[index].open = true;
    }

    return height > 0 ? height / 2 : null;
  }

  function applySidebarLayout() {
    if (isMobile()) {
      document.documentElement.style.removeProperty('--hero-top-offset');
      document.documentElement.style.removeProperty('--sidebar-nav-half-height');
      return;
    }

    var utility = document.querySelector('.site-header__utility');
    var header = document.querySelector('[data-site-header]');
    var anchor = utility || header;

    if (!anchor) return;

    var heroTopOffset = Math.ceil(anchor.getBoundingClientRect().bottom);
    var sidebarNavHalfHeight = measureSidebarNavHalfHeight();
    var rootStyle = getComputedStyle(document.documentElement);
    var currentHeroTopOffset = parseFloat(rootStyle.getPropertyValue('--hero-top-offset'));
    var currentHalfHeight = parseFloat(rootStyle.getPropertyValue('--sidebar-nav-half-height'));

    if (
      Math.abs(currentHeroTopOffset - heroTopOffset) < 1 &&
      sidebarNavHalfHeight != null &&
      Math.abs(currentHalfHeight - sidebarNavHalfHeight) < 1
    ) {
      cacheSidebarLayout(heroTopOffset, sidebarNavHalfHeight);
      return;
    }

    document.documentElement.style.setProperty('--hero-top-offset', heroTopOffset + 'px');

    if (sidebarNavHalfHeight != null) {
      document.documentElement.style.setProperty('--sidebar-nav-half-height', sidebarNavHalfHeight + 'px');
      cacheSidebarLayout(heroTopOffset, sidebarNavHalfHeight);
      return;
    }

    var cachedHalfHeight = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--sidebar-nav-half-height')
    );

    if (cachedHalfHeight > 0) {
      cacheSidebarLayout(heroTopOffset, cachedHalfHeight);
    }
  }

  function initSidebarLayout() {
    if (isMobile()) {
      applySidebarLayout();
      return;
    }

    function run() {
      requestAnimationFrame(applySidebarLayout);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(run);
      return;
    }

    run();
  }

  function getSectionScrollTop(index) {
    if (homepageScroll) {
      return homepageScroll.getSnapTop(index);
    }

    return index * getSectionHeight();
  }

  function createHomepageScroll() {
    var hero = document.querySelector('.hero');
    var featuredSections = Array.prototype.slice.call(
      document.querySelectorAll('[data-featured-collection]')
    );
    var footer = getFooterElements();
    var snapSections = [];
    var snapTops = [];

    function rebuildSnapSections() {
      snapSections.length = 0;

      if (hero) snapSections.push(hero);

      featuredSections.forEach(function (section) {
        snapSections.push(section);
      });

      if (footer.section) snapSections.push(footer.section);
    }

    rebuildSnapSections();

    function rebuildSnapTops() {
      var sectionHeight = getSectionHeight();

      snapTops = snapSections.map(function (_section, index) {
        return index * sectionHeight;
      });
    }

    function applySectionHeights() {
      var sectionHeight = getSectionHeight();
      var heightValue = sectionHeight + 'px';
      var stageHeightValue = sectionHeight + 2 + 'px';

      if (hero) {
        hero.style.height = heightValue;

        var heroGrid = hero.querySelector('.hero__grid');

        if (heroGrid) {
          heroGrid.style.height = heightValue;
        }
      }

      featuredSections.forEach(function (section) {
        section.style.height = heightValue;

        var stage = section.querySelector('.featured-collection__stage');

        if (stage) {
          stage.style.height = stageHeightValue;
        }
      });

      if (footer.section) {
        footer.section.style.height = heightValue;
      }

      if (footer.stage) {
        footer.stage.style.height = stageHeightValue;
      }
    }

    function applyFeaturedMeta() {
      featuredSections.forEach(function (section, index) {
        section.style.setProperty('--featured-z', String(2 + index));
      });

      if (footer.section) {
        footer.section.style.setProperty('--footer-z', String(2 + featuredSections.length));
      }

      featuredSections.forEach(function (section) {
        var image = section.querySelector('.featured-collection__image');

        if (image && !image.complete) {
          image.addEventListener('load', refreshLayout, { once: true });
        }
      });
    }

    function refreshLayout() {
      setViewportHeight();
      applySidebarLayout();
      applySectionHeights();
      void document.documentElement.offsetHeight;
      rebuildSnapTops();
      updatePinnedStages();
    }

    function resync() {
      hero = document.querySelector('.hero');

      var nextFeatured = Array.prototype.slice.call(
        document.querySelectorAll('[data-featured-collection]')
      );
      featuredSections.length = 0;
      nextFeatured.forEach(function (section) {
        featuredSections.push(section);
      });

      var nextFooter = getFooterElements();
      footer.section = nextFooter.section;
      footer.stage = nextFooter.stage;

      rebuildSnapSections();

      if (currentSectionIndex >= snapSections.length) {
        currentSectionIndex = Math.max(0, snapSections.length - 1);
      }

      applyFeaturedMeta();
      refreshLayout();
    }

    function getSnapTop(index) {
      if (snapTops[index] != null) {
        return snapTops[index];
      }

      return index * getSectionHeight();
    }

    function getFooterBlanketOffset() {
      return getSnapTop(featuredSections.length + 1);
    }

    function getNearestSnapIndex(scrollY) {
      var nearestIndex = 0;
      var nearestDistance = Infinity;

      snapTops.forEach(function (top, index) {
        var distance = Math.abs(scrollY - top);

        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = index;
        }
      });

      return nearestIndex;
    }

    function getCurrentSectionIndex() {
      return currentSectionIndex;
    }

    function setCurrentSectionIndex(index) {
      currentSectionIndex = index;
    }

    return {
      snapSections: snapSections,
      featuredSections: featuredSections,
      footer: footer,
      getSnapTop: getSnapTop,
      getFooterBlanketOffset: getFooterBlanketOffset,
      getNearestSnapIndex: getNearestSnapIndex,
      refreshLayout: refreshLayout,
      resync: resync,
      applyFeaturedMeta: applyFeaturedMeta,
      getCurrentSectionIndex: getCurrentSectionIndex,
      setCurrentSectionIndex: setCurrentSectionIndex
    };
  }

  setViewportHeight();
  initSidebarLayout();
  window.addEventListener('resize', scheduleHomepageLayoutRefresh);
  window.addEventListener('orientationchange', scheduleHomepageLayoutRefresh);

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', scheduleHomepageLayoutRefresh);
  }

  initMenu();
  initSearch();
  initCartDrawer();
  initPinnedStages();
  initHomepageScrollOrigin();
  initBlanketScroll();
  initMobileScrollSettle();
  initHeaderTheme();
  initCollectionLoadMore();
  initCollectionMobileNav();
  initProductPage();
  initPreorderBadge();
  initProductGalleryLightbox();
  initProductGalleryMobile();
  initProductKiwiSizeGuideRelocate();
  initProductAccordions();
  initLegalAccordions();
  initContactPage();
  initCookieBanner();
  initNewsletter();
  initChroniclesVideos();

  function initPreorderBadge() {
    var badge = document.querySelector('[data-preorder-badge]');
    var toggle = badge && badge.querySelector('[data-preorder-badge-toggle]');
    if (!toggle || !badge.querySelector('.product-preorder-badge__tooltip')) return;

    function setOpen(isOpen) {
      badge.classList.toggle('is-open', isOpen);
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    toggle.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      setOpen(!badge.classList.contains('is-open'));
    });

    document.addEventListener('click', function (event) {
      if (!badge.contains(event.target)) setOpen(false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') setOpen(false);
    });
  }

  function initChroniclesVideos() {
    document.addEventListener('click', function (event) {
      var playButton = event.target.closest('[data-chronicle-video-play]');
      if (!playButton) return;

      var wrap = playButton.closest('.chronicle-media__video-wrap');
      var video = wrap && wrap.querySelector('video');
      if (!video) return;

      event.preventDefault();
      video.controls = true;
      playButton.hidden = true;
      video.play().catch(function () {});
    });

    document.querySelectorAll('[data-chronicle-inline-video] video, .chronicle-media__video-wrap video').forEach(function (video) {
      video.controls = true;
      video.playsInline = true;
      video.setAttribute('controls', 'controls');
      video.setAttribute('playsinline', '');

      function syncVideoAspectRatio() {
        if (!video.videoWidth || !video.videoHeight) return;

        var wrap = video.closest('.chronicle-media__video-wrap');
        if (!wrap) return;

        wrap.style.setProperty(
          '--chronicle-video-aspect-ratio',
          video.videoWidth + ' / ' + video.videoHeight
        );
      }

      video.addEventListener('loadedmetadata', syncVideoAspectRatio);
      if (video.readyState >= 1) {
        syncVideoAspectRatio();
      }
    });
  }

  function initNewsletter() {
    var modal = document.querySelector('[data-newsletter-modal]');
    var triggers = document.querySelectorAll('[data-newsletter-trigger]');
    if (!modal || !triggers.length) return;

    var companyId = modal.getAttribute('data-klaviyo-company-id');
    var listId = modal.getAttribute('data-klaviyo-list-id');
    var form = modal.querySelector('[data-newsletter-form]');
    var emailInput = modal.querySelector('[data-newsletter-email]');
    var fields = modal.querySelector('[data-newsletter-fields]');
    var successMessage = modal.querySelector('[data-newsletter-success]');
    var errorMessage = modal.querySelector('[data-newsletter-error]');
    var submitting = false;

    function openModal() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('newsletter-open');

      resetFormState();

      window.setTimeout(function () {
        if (emailInput) {
          emailInput.focus();
        }
      }, 150);
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('newsletter-open');
    }

    function resetFormState() {
      submitting = false;

      if (form) {
        form.hidden = false;
      }

      if (fields) {
        fields.hidden = false;
      }

      if (successMessage) {
        successMessage.hidden = true;
      }

      if (errorMessage) {
        errorMessage.hidden = true;
        errorMessage.textContent = '';
      }

      if (emailInput) {
        emailInput.value = '';
      }
    }

    function showSuccess() {
      if (form) {
        form.hidden = true;
      }

      if (successMessage) {
        successMessage.hidden = false;
      }
    }

    function showError(text) {
      if (errorMessage) {
        errorMessage.textContent = text;
        errorMessage.hidden = false;
      }
    }

    function subscribeEmail(email) {
      if (!companyId || !listId) {
        return Promise.reject(new Error('Newsletter signup is not configured.'));
      }

      return fetch(
        'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/vnd.api+json',
            revision: '2026-04-15',
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Nostalgia footer newsletter',
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: email,
                    },
                  },
                },
              },
              relationships: {
                list: {
                  data: {
                    type: 'list',
                    id: listId,
                  },
                },
              },
            },
          }),
        }
      );
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        openModal();
      });
    });

    modal.querySelectorAll('[data-newsletter-close]').forEach(function (node) {
      node.addEventListener('click', function () {
        closeModal();
      });
    });

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();

        if (submitting || !emailInput) return;

        if (!emailInput.checkValidity()) {
          emailInput.reportValidity();
          return;
        }

        submitting = true;

        if (errorMessage) {
          errorMessage.hidden = true;
          errorMessage.textContent = '';
        }

        subscribeEmail(emailInput.value.trim())
          .then(function (response) {
            if (response.status === 202 || response.ok) {
              showSuccess();
              return;
            }

            return response.text().then(function (body) {
              var message = 'something went wrong. please try again.';

              try {
                var payload = JSON.parse(body);
                if (payload.errors && payload.errors[0] && payload.errors[0].detail) {
                  message = payload.errors[0].detail;
                }
              } catch (parseError) {
                // Keep the generic message when Klaviyo returns non-JSON.
              }

              throw new Error(message);
            });
          })
          .catch(function (error) {
            showError(error && error.message ? error.message : 'something went wrong. please try again.');
          })
          .finally(function () {
            submitting = false;
          });
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    });
  }

  function openChatbaseWidget(attempt) {
    var tries = attempt || 0;

    if (window.chatbase) {
      if (typeof window.chatbase === 'function') {
        window.chatbase('open');
        return;
      }

      if (typeof window.chatbase.open === 'function') {
        window.chatbase.open();
        return;
      }
    }

    var bubbleButton = document.getElementById('chatbase-bubble-button');

    if (bubbleButton && typeof bubbleButton.click === 'function') {
      bubbleButton.click();
      return;
    }

    if (tries < 40) {
      window.setTimeout(function () {
        openChatbaseWidget(tries + 1);
      }, 150);
    }
  }

  function initContactPage() {
    initExclusiveAccordions('[data-contact-faq-accordions]', 'details.contact-faq-accordion');

    var trigger = document.querySelector('[data-contact-chat-trigger]');
    if (!trigger) return;

    trigger.addEventListener('click', function () {
      openChatbaseWidget();
    });
  }

  function initCookieBanner() {
    var customized = false;
    var observer = null;

    function customizeBanner() {
      if (customized) return;

      var banner = document.getElementById('shopify-pc__banner');
      if (!banner) return;

      var prefsBtn = document.getElementById('shopify-pc__banner__btn-manage-prefs');
      var privacyLink = banner.querySelector('.shopify-pc__banner__body a');
      var legalPrivacyUrl = document.body.getAttribute('data-legal-privacy-url');

      if (!prefsBtn && !privacyLink) return;

      if (prefsBtn) {
        prefsBtn.textContent = 'preferences';
      }

      if (privacyLink && legalPrivacyUrl) {
        privacyLink.href = legalPrivacyUrl;
      }

      customized = true;

      if (observer) {
        observer.disconnect();
        observer = null;
      }
    }

    customizeBanner();
    if (customized) return;

    observer = new MutationObserver(customizeBanner);
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    window.setTimeout(function () {
      if (!observer) return;
      observer.disconnect();
      observer = null;
    }, 10000);
  }

  function initExclusiveAccordions(groupSelector, accordionSelector) {
    var accordionGroup = document.querySelector(groupSelector);
    if (!accordionGroup) return;

    var accordions = accordionGroup.querySelectorAll(accordionSelector);
    if (accordions.length < 2) return;

    accordions.forEach(function (accordion) {
      accordion.addEventListener('toggle', function () {
        if (!accordion.open) return;

        accordions.forEach(function (other) {
          if (other !== accordion) {
            other.open = false;
          }
        });
      });
    });
  }

  function initProductAccordions() {
    initExclusiveAccordions('[data-product-accordions]', 'details.product-accordion');
  }

  function initLegalAccordions() {
    initExclusiveAccordions('[data-legal-accordions]', 'details.legal-accordion');

    var privacyAccordion = document.getElementById('legal-privacy');
    if (!privacyAccordion) return;

    function openPrivacyFromHash() {
      if (window.location.hash !== '#legal-privacy') return;

      privacyAccordion.open = true;
      window.setTimeout(function () {
        privacyAccordion.scrollIntoView({ block: 'start' });
      }, 0);
    }

    openPrivacyFromHash();
    window.addEventListener('hashchange', openPrivacyFromHash);
  }

  function initProductPage() {
    var page = document.querySelector('[data-product-page]');
    if (!page) return;

    var form = page.querySelector('.product-form');
    var variantsNode = page.querySelector('[data-product-variants]');
    var optionsNode = page.querySelector('[data-product-options]');
    if (!form || !variantsNode || !optionsNode) return;

    var variants;
    var optionNames;

    try {
      variants = JSON.parse(variantsNode.textContent);
      optionNames = JSON.parse(optionsNode.textContent);
    } catch (error) {
      return;
    }
    var variantInput = form.querySelector('[data-product-variant-id]');
    var priceEl = page.querySelector('[data-product-price]');
    var addButton = form.querySelector('[data-product-add-button]');
    var purchaseActions = form.querySelector('[data-product-purchase-actions]');
    var paymentTerms = form.querySelector('shopify-payment-terms');
    var paymentTermsColor = 'rgba(0, 0, 0, 0.55)';
    var optionButtons = Array.prototype.slice.call(
      form.querySelectorAll('[data-option-position][data-option-value]')
    );
    var selectedOptions = {};

    optionNames.forEach(function (_name, index) {
      var position = index + 1;
      var selectedButton = form.querySelector(
        '[data-option-position="' + position + '"].is-selected'
      );

      selectedOptions[position] = selectedButton
        ? selectedButton.dataset.optionValue
        : null;
    });

    if (optionButtons.length === 0 && variantInput && variantInput.value) {
      var initialVariant = variants.find(function (variant) {
        return String(variant.id) === String(variantInput.value);
      });

      if (initialVariant) {
        initialVariant.options.forEach(function (value, index) {
          selectedOptions[index + 1] = value;
        });
      }
    }

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents);
      }

      return '$' + (cents / 100).toFixed(2);
    }

    function findVariant() {
      return variants.find(function (variant) {
        return variant.options.every(function (value, index) {
          return value === selectedOptions[index + 1];
        });
      });
    }

    function optionValueIsAvailable(position, value) {
      return variants.some(function (variant) {
        if (!variant.available) return false;

        return variant.options.every(function (optionValue, index) {
          var optionPosition = index + 1;

          if (optionPosition === position) {
            return optionValue === value;
          }

          if (!selectedOptions[optionPosition]) {
            return true;
          }

          return optionValue === selectedOptions[optionPosition];
        });
      });
    }

    function updateOptionAvailability() {
      optionButtons.forEach(function (button) {
        var position = parseInt(button.dataset.optionPosition, 10);
        var value = button.dataset.optionValue;
        var isAvailable = optionValueIsAvailable(position, value);

        button.classList.toggle('is-unavailable', !isAvailable);
        button.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
      });
    }

    function updateSelectedButtons() {
      optionButtons.forEach(function (button) {
        var position = parseInt(button.dataset.optionPosition, 10);
        var isSelected = button.dataset.optionValue === selectedOptions[position];

        button.classList.toggle('is-selected', isSelected);
        button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });
    }

    function stylePaymentTermsColor() {
      if (!paymentTerms) return;

      paymentTerms.style.setProperty('color', paymentTermsColor, 'important');

      var shadow = paymentTerms.shadowRoot;
      if (!shadow || shadow.querySelector('[data-product-payment-terms-style]')) return;

      var style = document.createElement('style');
      style.setAttribute('data-product-payment-terms-style', '');
      style.textContent =
        ':host { color: ' +
        paymentTermsColor +
        ' !important; } p, span, div, button { color: inherit !important; }';
      shadow.appendChild(style);
    }

    function syncPurchaseActions(isAvailable) {
      var purchaseState = isAvailable ? 'available' : 'sold-out';

      if (purchaseActions) {
        purchaseActions.dataset.state = purchaseState;
      }

      form.classList.toggle('product-form--sold-out', !isAvailable);

      if (addButton) {
        addButton.disabled = !isAvailable;
        addButton.removeAttribute('hidden');
      }
    }

    function notifyVariantChange(variant) {
      if (!variantInput || !variant) return;

      variantInput.value = variant.id;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      variantInput.dispatchEvent(new Event('input', { bubbles: true }));
    }

    function updateVariantUI() {
      var variant = findVariant();
      var isAvailable = Boolean(variant && variant.available);

      updateOptionAvailability();
      updateSelectedButtons();
      syncPurchaseActions(isAvailable);

      if (!variant) {
        return;
      }

      if (variantInput) {
        variantInput.value = variant.id;
      }

      if (priceEl) {
        var currentEl = priceEl.querySelector('[data-product-price-current]');
        var compareEl = priceEl.querySelector('[data-product-price-compare]');

        if (currentEl) {
          currentEl.textContent = formatMoney(variant.price);
        }

        if (compareEl) {
          var onSale =
            variant.compare_at_price && variant.compare_at_price > variant.price;

          if (onSale) {
            compareEl.textContent = formatMoney(variant.compare_at_price);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        } else if (!currentEl) {
          priceEl.textContent = formatMoney(variant.price);
        }
      }

      if (paymentTerms) {
        paymentTerms.setAttribute('variant-id', String(variant.id));
        stylePaymentTermsColor();
      }

      notifyVariantChange(variant);
    }

    optionButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var position = parseInt(button.dataset.optionPosition, 10);
        selectedOptions[position] = button.dataset.optionValue;
        updateVariantUI();
      });
    });

    updateVariantUI();
    stylePaymentTermsColor();

    if (paymentTerms) {
      var paymentTermsObserver = new MutationObserver(stylePaymentTermsColor);
      paymentTermsObserver.observe(paymentTerms, {
        childList: true,
        subtree: true
      });
    }
  }

  function initProductGalleryMobile() {
    var gallery = document.querySelector('[data-product-gallery]');
    if (!gallery) return;

    var track = gallery.querySelector('[data-product-gallery-track]');
    var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-product-gallery-dot]'));

    if (!track || dots.length < 2) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-product-gallery-slide]'));
    var activeIndex = 0;
    var scrollTicking = false;

    function setActiveDot(index) {
      if (index < 0 || index >= dots.length || index === activeIndex) return;

      activeIndex = index;

      dots.forEach(function (dot, dotIndex) {
        var isActive = dotIndex === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    function getActiveIndexFromScroll() {
      var trackWidth = track.clientWidth;

      if (!trackWidth) return 0;

      var index = Math.round(track.scrollLeft / trackWidth);
      return Math.max(0, Math.min(index, slides.length - 1));
    }

    function scrollToSlide(index) {
      var trackWidth = track.clientWidth;

      if (!trackWidth || index < 0 || index >= slides.length) return;

      track.scrollTo({
        left: index * trackWidth,
        behavior: 'smooth'
      });
      setActiveDot(index);
    }

    track.addEventListener(
      'scroll',
      function () {
        if (scrollTicking) return;

        scrollTicking = true;

        requestAnimationFrame(function () {
          scrollTicking = false;
          setActiveDot(getActiveIndexFromScroll());
        });
      },
      { passive: true }
    );

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.dataset.slideIndex, 10);

        if (!Number.isNaN(index)) {
          scrollToSlide(index);
        }
      });
    });
  }

  function initProductGalleryLightbox() {
    var gallery = document.querySelector('[data-product-gallery]');
    var dataNode = document.querySelector('[data-product-gallery-data]');
    var lightbox = document.querySelector('[data-product-gallery-lightbox]');
    if (!gallery || !dataNode || !lightbox) return;

    var galleryData;

    try {
      galleryData = JSON.parse(dataNode.textContent);
    } catch (error) {
      return;
    }

    var images = galleryData.images || [];
    if (!images.length) return;

    var stage = lightbox.querySelector('[data-product-gallery-stage]');
    var imageEl = lightbox.querySelector('[data-product-gallery-lightbox-image]');
    var closeButton = lightbox.querySelector('[data-product-gallery-close]');
    var prevButton = lightbox.querySelector('[data-product-gallery-prev]');
    var nextButton = lightbox.querySelector('[data-product-gallery-next]');
    var openButtons = Array.prototype.slice.call(
      gallery.querySelectorAll('[data-product-gallery-open]')
    );
    var activeIndex = 0;
    var lastFocus = null;

    function resetScroll() {
      lightbox.scrollTop = 0;
    }

    function setImage(index) {
      var image = images[index];
      if (!image || !imageEl) return;

      activeIndex = index;
      imageEl.src = image.src;
      imageEl.alt = image.alt || '';
      resetScroll();

      if (prevButton) {
        prevButton.disabled = index === 0;
      }

      if (nextButton) {
        nextButton.disabled = index === images.length - 1;
      }
    }

    function openLightbox(index) {
      if (index < 0 || index >= images.length) return;

      lastFocus = document.activeElement;
      setImage(index);
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('product-gallery-open');
      resetScroll();

      if (closeButton) {
        closeButton.focus();
      }
    }

    function closeLightbox() {
      lightbox.hidden = true;
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('product-gallery-open');

      if (imageEl) {
        imageEl.removeAttribute('src');
      }

      if (lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus();
      }
    }

    function showPrevious() {
      if (activeIndex > 0) {
        setImage(activeIndex - 1);
      }
    }

    function showNext() {
      if (activeIndex < images.length - 1) {
        setImage(activeIndex + 1);
      }
    }

    openButtons.forEach(function (button) {
      var pressStart = null;

      button.addEventListener('pointerdown', function (event) {
        pressStart = { x: event.clientX, y: event.clientY };
      });

      button.addEventListener('click', function (event) {
        if (pressStart) {
          var deltaX = Math.abs(event.clientX - pressStart.x);
          var deltaY = Math.abs(event.clientY - pressStart.y);
          pressStart = null;

          if (deltaX > 10 || deltaY > 10) {
            return;
          }
        }

        var index = parseInt(button.dataset.imageIndex, 10);
        if (!Number.isNaN(index)) {
          openLightbox(index);
        }
      });
    });

    if (closeButton) {
      closeButton.addEventListener('click', closeLightbox);
    }

    if (prevButton) {
      prevButton.addEventListener('click', showPrevious);
    }

    if (nextButton) {
      nextButton.addEventListener('click', showNext);
    }

    document.addEventListener('keydown', function (event) {
      if (lightbox.hidden) return;

      if (event.key === 'Escape') {
        closeLightbox();
        return;
      }

      if (event.key === 'ArrowLeft') {
        showPrevious();
        return;
      }

      if (event.key === 'ArrowRight') {
        showNext();
      }
    });
  }

  function initProductKiwiSizeGuideRelocate() {
    var chartHost = document.getElementById('KiwiSizingChart');
    if (!chartHost) return;

    var CHART_SELECTOR =
      '.ks-chart-container, .ks-table-wrapper, .ks-layout-group, .ks-chart-individual, table.ks-table';

    function getChartRoot(node) {
      if (!node) return null;

      return (
        node.closest('.ks-chart-container, .ks-table-wrapper, .ks-layout-group, .ks-chart-individual') ||
        node
      );
    }

    function relocateKiwiChart() {
      var seen = [];

      Array.prototype.slice.call(document.querySelectorAll(CHART_SELECTOR)).forEach(function (node) {
        var root = getChartRoot(node);
        if (!root || seen.indexOf(root) !== -1 || chartHost.contains(root)) return;

        seen.push(root);
        chartHost.appendChild(root);
      });
    }

    relocateKiwiChart();

    window.addEventListener('load', function () {
      window.setTimeout(relocateKiwiChart, 250);
      window.setTimeout(relocateKiwiChart, 1500);
    });

    var productPage = document.querySelector('[data-product-page]');
    if (!productPage) return;

    var kiwiObserver = new MutationObserver(relocateKiwiChart);
    kiwiObserver.observe(productPage, {
      childList: true,
      subtree: true
    });
  }

  function initCollectionMobileNav() {
    document.querySelectorAll('[data-collection-mobile-nav]').forEach(function (nav) {
      var toggle = nav.querySelector('[data-collection-mobile-nav-toggle]');

      if (!toggle) return;

      toggle.addEventListener('click', function () {
        var isOpen = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  }

  function initCollectionLoadMore() {
    var listing = document.querySelector('[data-collection-listing]');
    if (!listing) return;

    var sectionId = listing.dataset.sectionId;
    var grid = listing.querySelector('[data-collection-grid]');
    var sentinel = listing.querySelector('[data-collection-load-sentinel]');
    if (!sectionId || !grid || !sentinel) return;

    var isLoading = false;
    var observer;

    function appendNextPage(nextUrl) {
      if (!nextUrl || isLoading) return;

      isLoading = true;
      var requestUrl = new URL(nextUrl, window.location.origin);
      requestUrl.searchParams.set('section_id', sectionId);

      fetch(requestUrl.toString(), {
        headers: {
          Accept: 'text/html',
        },
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Collection load failed');
          }
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nextGrid = doc.querySelector('[data-collection-grid]');
          if (!nextGrid) return;

          Array.prototype.forEach.call(nextGrid.querySelectorAll('.product-card'), function (card) {
            grid.appendChild(card);
          });

          var nextSentinel = doc.querySelector('[data-collection-load-sentinel]');
          if (nextSentinel && nextSentinel.dataset.nextUrl) {
            sentinel.dataset.nextUrl = nextSentinel.dataset.nextUrl;
          } else if (observer) {
            observer.disconnect();
            sentinel.remove();
          }
        })
        .catch(function () {
          if (observer) {
            observer.disconnect();
          }
        })
        .finally(function () {
          isLoading = false;
        });
    }

    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            appendNextPage(sentinel.dataset.nextUrl);
          }
        });
      },
      {
        root: null,
        rootMargin: '600px 0px',
        threshold: 0,
      }
    );

    observer.observe(sentinel);
  }

  function initMenu() {
    var menuOverlay = document.querySelector('[data-menu-overlay]');
    var menuOpen = document.querySelector('[data-menu-open]');
    var menuClose = document.querySelector('[data-menu-close]');

    if (!menuOverlay || !menuOpen) return;

    function openMenu() {
      var searchOverlay = document.querySelector('[data-search-overlay]');
      var searchOpen = document.querySelector('[data-search-open]');
      var cartDrawer = document.querySelector('[data-cart-drawer]');

      if (searchOverlay && searchOverlay.classList.contains('is-open')) {
        searchOverlay.classList.remove('is-open');
        searchOverlay.setAttribute('aria-hidden', 'true');

        if (searchOpen) {
          searchOpen.setAttribute('aria-expanded', 'false');
        }

        document.body.classList.remove('search-open');
      }

      if (cartDrawer && cartDrawer.classList.contains('is-open')) {
        cartDrawer.classList.remove('is-open');
        cartDrawer.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('cart-open');
        document.querySelectorAll('[data-cart-open]').forEach(function (button) {
          button.setAttribute('aria-expanded', 'false');
        });
      }

      menuOverlay.classList.add('is-open');
      menuOverlay.setAttribute('aria-hidden', 'false');
      menuOpen.setAttribute('aria-expanded', 'true');
      document.body.classList.add('menu-open');
    }

    function closeMenu() {
      menuOverlay.classList.remove('is-open');
      menuOverlay.setAttribute('aria-hidden', 'true');
      menuOpen.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('menu-open');

      menuOverlay.querySelectorAll('.menu-overlay__dropdown').forEach(function (details) {
        details.open = false;
      });
    }

    menuOpen.addEventListener('click', openMenu);

    if (menuClose) {
      menuClose.addEventListener('click', closeMenu);
    }

    menuOverlay.querySelectorAll('.menu-overlay__link[href]').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });

    menuOverlay.addEventListener('click', function (event) {
      if (event.target === menuOverlay) {
        closeMenu();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && menuOverlay.classList.contains('is-open')) {
        closeMenu();
      }
    });
  }

  function initSearch() {
    var searchOverlay = document.querySelector('[data-search-overlay]');
    var searchOpen = document.querySelector('[data-search-open]');
    var searchClose = document.querySelector('[data-search-close]');
    var searchInput = searchOverlay
      ? searchOverlay.querySelector('.search-overlay__input')
      : null;
    var menuOverlay = document.querySelector('[data-menu-overlay]');
    var menuOpen = document.querySelector('[data-menu-open]');

    if (!searchOverlay || !searchOpen) return;

    function closeMenuIfOpen() {
      if (!menuOverlay || !menuOverlay.classList.contains('is-open')) return;

      menuOverlay.classList.remove('is-open');
      menuOverlay.setAttribute('aria-hidden', 'true');

      if (menuOpen) {
        menuOpen.setAttribute('aria-expanded', 'false');
      }

      document.body.classList.remove('menu-open');

      menuOverlay.querySelectorAll('.menu-overlay__dropdown').forEach(function (details) {
        details.open = false;
      });
    }

    function openSearch() {
      closeMenuIfOpen();

      var cartDrawer = document.querySelector('[data-cart-drawer]');
      if (cartDrawer && cartDrawer.classList.contains('is-open')) {
        cartDrawer.classList.remove('is-open');
        cartDrawer.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('cart-open');
        document.querySelectorAll('[data-cart-open]').forEach(function (button) {
          button.setAttribute('aria-expanded', 'false');
        });
      }

      searchOverlay.classList.add('is-open');
      searchOverlay.setAttribute('aria-hidden', 'false');
      searchOpen.setAttribute('aria-expanded', 'true');
      document.body.classList.add('search-open');

      if (searchInput) {
        window.requestAnimationFrame(function () {
          searchInput.focus();
        });
      }
    }

    function closeSearch() {
      searchOverlay.classList.remove('is-open');
      searchOverlay.setAttribute('aria-hidden', 'true');
      searchOpen.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('search-open');
    }

    searchOpen.addEventListener('click', openSearch);

    if (searchClose) {
      searchClose.addEventListener('click', closeSearch);
    }

    searchOverlay.addEventListener('click', function (event) {
      if (event.target === searchOverlay) {
        closeSearch();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && searchOverlay.classList.contains('is-open')) {
        closeSearch();
      }
    });
  }

  function formatShopMoney(cents, format) {
    var amount = Number(cents);

    if (Number.isNaN(amount)) {
      return '';
    }

    var formatString = format || '${{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      var num = (number / 100).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';

      return dollars + centsPart;
    }

    var match = formatString.match(/\{\{\s*(\w+)\s*\}\}/);

    if (!match) {
      return formatString;
    }

    switch (match[1]) {
      case 'amount_no_decimals':
        return formatString.replace(match[0], formatWithDelimiters(amount, 0, ',', '.'));
      case 'amount_with_comma_separator':
        return formatString.replace(match[0], formatWithDelimiters(amount, 2, '.', ','));
      case 'amount_no_decimals_with_comma_separator':
        return formatString.replace(match[0], formatWithDelimiters(amount, 0, '.', ','));
      case 'amount':
      default:
        return formatString.replace(match[0], formatWithDelimiters(amount, 2, ',', '.'));
    }
  }

  function initCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    var cartOpenButtons = Array.prototype.slice.call(
      document.querySelectorAll('[data-cart-open]')
    );
    var cartCloseButtons = Array.prototype.slice.call(
      document.querySelectorAll('[data-cart-close]')
    );
    var bodyEl = drawer.querySelector('[data-cart-drawer-body]');
    var footerEl = drawer.querySelector('[data-cart-drawer-footer]');
    var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
    var searchOverlay = document.querySelector('[data-search-overlay]');
    var searchOpen = document.querySelector('[data-search-open]');
    var menuOverlay = document.querySelector('[data-menu-overlay]');
    var menuOpen = document.querySelector('[data-menu-open]');
    var moneyFormat = drawer.dataset.moneyFormat || '${{amount}}';
    var freeShippingThreshold = parseInt(drawer.dataset.freeShippingThreshold, 10) || 0;
    var continueShoppingUrl = drawer.dataset.continueShoppingUrl || '/collections/all';
    var isUpdating = false;

    function updateCartCounts(count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (node) {
        node.textContent = String(count);
      });
    }

    function getShippingMessage(totalCents) {
      if (!freeShippingThreshold) {
        return '';
      }

      var remaining = freeShippingThreshold - totalCents;

      if (remaining <= 0) {
        return 'you qualify for free shipping!';
      }

      return (
        'only ' +
        formatShopMoney(remaining, moneyFormat) +
        ' away from free shipping!'
      );
    }

    function updateShippingMessage(totalCents) {
      var messageEl = drawer.querySelector('[data-cart-shipping-message]');
      if (!messageEl) return;
      messageEl.textContent = getShippingMessage(totalCents);
    }

    function escapeHtml(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function buildItemHtml(item) {
      var imageUrl = item.image || (item.featured_image && item.featured_image.url) || '';
      var productTitle = item.product_title || item.title || '';
      var imageHtml =
        imageUrl
          ? '<img class="cart-drawer__item-image" src="' +
            escapeHtml(imageUrl) +
            '" alt="' +
            escapeHtml(productTitle) +
            '" loading="lazy" width="120" height="120">'
          : '<span class="cart-drawer__item-image cart-drawer__item-image--placeholder" aria-hidden="true"></span>';
      var variantHtml =
        item.variant_title && item.variant_title !== 'Default Title'
          ? '<p class="cart-drawer__item-variant">' +
            escapeHtml(item.variant_title.toLowerCase()) +
            '</p>'
          : '';
      var preorderValue = item.properties && item.properties['Pre-order'];
      var preorderHtml = preorderValue
        ? '<p class="cart-drawer__item-variant cart-drawer__item-preorder">pre-order' +
          (preorderValue !== 'yes' ? ' · ' + escapeHtml(preorderValue) : '') +
          '</p>'
        : '';
      var title = escapeHtml(productTitle.toLowerCase());
      var itemUrl = escapeHtml(item.url || '');
      var lineKey = escapeHtml(item.key || '');

      return (
        '<li class="cart-drawer__item" data-cart-drawer-item data-line-key="' +
        lineKey +
        '">' +
        '<a class="cart-drawer__item-media" href="' +
        itemUrl +
        '">' +
        imageHtml +
        '</a>' +
        '<div class="cart-drawer__item-details">' +
        '<a class="cart-drawer__item-title" href="' +
        itemUrl +
        '">' +
        title +
        '</a>' +
        variantHtml +
        preorderHtml +
        '<p class="cart-drawer__item-price">' +
        formatShopMoney(item.final_line_price, moneyFormat) +
        '</p>' +
        '<div class="cart-drawer__item-actions">' +
        '<div class="cart-drawer__qty">' +
        '<button class="cart-drawer__qty-button" type="button" data-cart-qty-change="-1" data-line-key="' +
        lineKey +
        '" aria-label="Decrease quantity">−</button>' +
        '<span class="cart-drawer__qty-value" data-cart-item-quantity>' +
        item.quantity +
        '</span>' +
        '<button class="cart-drawer__qty-button" type="button" data-cart-qty-change="1" data-line-key="' +
        lineKey +
        '" aria-label="Increase quantity">+</button>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</li>'
      );
    }

    function renderEmptyState() {
      if (!bodyEl) return;

      bodyEl.innerHTML =
        '<div class="cart-drawer__empty" data-cart-drawer-empty>' +
        '<p class="cart-drawer__empty-text">your cart is empty</p>' +
        '<a class="cart-drawer__empty-button" href="' +
        continueShoppingUrl +
        '">start shopping</a>' +
        '</div>';

      if (footerEl) {
        footerEl.hidden = true;
      }
    }

    function renderCart(cart) {
      updateCartCounts(cart.item_count);

      if (!bodyEl) return;

      if (!cart.item_count) {
        renderEmptyState();
        return;
      }

      bodyEl.innerHTML =
        '<ul class="cart-drawer__items" data-cart-drawer-items>' +
        cart.items.map(buildItemHtml).join('') +
        '</ul>' +
        '<p class="cart-drawer__shipping" data-cart-shipping-message></p>';

      if (footerEl) {
        footerEl.hidden = false;
      }

      if (subtotalEl) {
        subtotalEl.textContent = formatShopMoney(cart.total_price, moneyFormat);
      }

      updateShippingMessage(cart.total_price);
    }

    function fetchCart() {
      return fetch('/cart.js', {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('Cart request failed');
        }

        return response.json();
      });
    }

    function refreshCart() {
      return fetchCart().then(renderCart);
    }

    function changeLineQuantity(lineKey, quantity) {
      if (isUpdating) {
        return Promise.resolve();
      }

      isUpdating = true;

      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: Math.max(0, quantity)
        })
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Cart update failed');
          }

          return response.json();
        })
        .then(function (cart) {
          renderCart(cart);
          return cart;
        })
        .finally(function () {
          isUpdating = false;
        });
    }

    function closeMenuIfOpen() {
      if (!menuOverlay || !menuOverlay.classList.contains('is-open')) return;

      menuOverlay.classList.remove('is-open');
      menuOverlay.setAttribute('aria-hidden', 'true');

      if (menuOpen) {
        menuOpen.setAttribute('aria-expanded', 'false');
      }

      document.body.classList.remove('menu-open');

      menuOverlay.querySelectorAll('.menu-overlay__dropdown').forEach(function (details) {
        details.open = false;
      });
    }

    function closeSearchIfOpen() {
      if (!searchOverlay || !searchOverlay.classList.contains('is-open')) return;

      searchOverlay.classList.remove('is-open');
      searchOverlay.setAttribute('aria-hidden', 'true');

      if (searchOpen) {
        searchOpen.setAttribute('aria-expanded', 'false');
      }

      document.body.classList.remove('search-open');
    }

    function openCart() {
      closeMenuIfOpen();
      closeSearchIfOpen();
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      cartOpenButtons.forEach(function (button) {
        button.setAttribute('aria-expanded', 'true');
      });
      document.body.classList.add('cart-open');
      refreshCart();
    }

    function closeCart() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      cartOpenButtons.forEach(function (button) {
        button.setAttribute('aria-expanded', 'false');
      });
      document.body.classList.remove('cart-open');
    }

    cartOpenButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        openCart();
      });
    });

    cartCloseButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        closeCart();
      });
    });

    drawer.addEventListener('click', function (event) {
      var qtyButton = event.target.closest('[data-cart-qty-change]');
      if (qtyButton) {
        var lineKey = qtyButton.dataset.lineKey;
        var delta = parseInt(qtyButton.dataset.cartQtyChange, 10);
        var qtyNode = qtyButton
          .closest('.cart-drawer__qty')
          .querySelector('[data-cart-item-quantity]');
        var currentQty = parseInt(qtyNode.textContent, 10) || 0;

        changeLineQuantity(lineKey, currentQty + delta);
      }
    });

    document.addEventListener('click', function (event) {
      if (!drawer.classList.contains('is-open')) return;
      if (!isDesktopLayout()) return;
      if (event.target.closest('[data-cart-drawer-panel]')) return;
      if (event.target.closest('[data-cart-open]')) return;
      closeCart();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeCart();
      }
    });

    document.addEventListener('submit', function (event) {
      var form = event.target;

      if (!(form instanceof HTMLFormElement) || form.action.indexOf('/cart/add') === -1) {
        return;
      }

      event.preventDefault();

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        },
        body: new FormData(form)
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Add to cart failed');
          }

          return response.json();
        })
        .then(function () {
          openCart();
        })
        .catch(function () {
          form.submit();
        });
    });

    fetchCart()
      .then(function (cart) {
        updateCartCounts(cart.item_count);
        updateShippingMessage(cart.total_price);
      })
      .catch(function () {});
  }

  function getFooterElements() {
    var footerStage = document.querySelector('[data-site-footer]');
    if (!footerStage) return { section: null, stage: null };

    return {
      section: footerStage.closest('.site-footer'),
      stage: footerStage
    };
  }

  function initHeaderTheme() {
    var header = document.querySelector('[data-site-header]');
    var heroScroll = document.querySelector('.hero__scroll');

    if (!header || !homepageScroll) return;

    var featuredSections = homepageScroll.featuredSections;
    var footer = homepageScroll.footer;
    var heroTheme = 'dark';
    var themeReveal = 0.35;

    function applyTheme(theme) {
      header.setAttribute('data-header-theme', theme);
    }

    function updateScrollState() {
      var viewportHeight = getSectionHeight();
      var scrollY = getScrollY();

      if (heroScroll && featuredSections.length > 0) {
        var firstFeaturedTop = homepageScroll.getSnapTop(1) - scrollY;
        var coverProgress = 1 - firstFeaturedTop / viewportHeight;
        heroScroll.classList.toggle('is-hidden', coverProgress > 0.08);
      }

      if (
        footer.section &&
        scrollY >= homepageScroll.getFooterBlanketOffset() - viewportHeight * themeReveal
      ) {
        applyTheme(footer.stage.dataset.headerTheme || 'dark');
        return;
      }

      if (!featuredSections.length || scrollY < viewportHeight * 0.15) {
        applyTheme(heroTheme);
        return;
      }

      var activeSection = featuredSections[0];

      featuredSections.forEach(function (section, index) {
        if (scrollY >= homepageScroll.getSnapTop(index + 1) - viewportHeight * themeReveal) {
          activeSection = section;
        }
      });

      applyTheme(activeSection.dataset.headerTheme || 'light');
    }

    subscribeScroll(updateScrollState);
    window.addEventListener('resize', updateScrollState);
    prefersReducedMotion.addEventListener('change', updateScrollState);
    updateScrollState();
  }

  function initBlanketScroll() {
    if (!document.body.classList.contains('template-index')) return;
    if (!homepageScroll) return;

    var snapSections = homepageScroll.snapSections;

    if (snapSections.length < 2) return;

    var transitionMs = isMobile() ? BLANKET_TRANSITION_MS_MOBILE : BLANKET_TRANSITION_MS;
    var wheelIntentDeltaThreshold = 48;
    var wheelGestureGapMs = 72;
    var rootElement = document.documentElement;
    var previousScrollBehavior = '';
    var gestureNavUsed = false;
    var lastWheelAt = 0;

    function isScrollLocked() {
      return (
        blanketAnimating ||
        document.body.classList.contains('menu-open') ||
        document.body.classList.contains('search-open')
      );
    }

    function normalizeWheelDelta(event) {
      var delta = Math.abs(event.deltaY);

      if (event.deltaMode === 1) {
        return delta * 16;
      }

      if (event.deltaMode === 2) {
        return delta * getSectionHeight();
      }

      return delta;
    }

    function isStrongWheelIntent(event, normalizedDelta) {
      if (event.deltaMode === 1) {
        return Math.abs(event.deltaY) >= 1;
      }

      if (event.deltaMode === 2) {
        return true;
      }

      return normalizedDelta >= wheelIntentDeltaThreshold;
    }

    function shouldNavigateOnWheel(event) {
      var now = performance.now();
      var gap = lastWheelAt ? now - lastWheelAt : Infinity;
      var normalizedDelta = normalizeWheelDelta(event);

      lastWheelAt = now;

      if (blanketAnimating) return false;

      if (gap > wheelGestureGapMs) {
        gestureNavUsed = false;
      }

      if (!gestureNavUsed) {
        return true;
      }

      return isStrongWheelIntent(event, normalizedDelta);
    }

    function scrollWindowTo(y) {
      window.scrollTo(0, y);
    }

    function snapToCurrentSection() {
      scrollWindowTo(homepageScroll.getSnapTop(currentSectionIndex));
      updatePinnedStages(homepageScroll.getSnapTop(currentSectionIndex));
    }

    animateBlanketScrollTo = function (targetY, options) {
      options = options || {};
      var startY = getScrollY();
      var distance = targetY - startY;
      var scrollDuration =
        options.duration != null
          ? options.duration
          : options.sectionTransition
            ? transitionMs
            : Math.min(
                Math.max((Math.abs(distance) / getSectionHeight()) * transitionMs, 220),
                780
              );
      var easing = options.easing || easeInOutCubic;
      var startTime = null;

      if (Math.abs(distance) < 2 || scrollDuration === 0) {
        scrollWindowTo(targetY);
        updatePinnedStages(targetY);
        blanketAnimating = false;
        return Promise.resolve();
      }

      if (Math.abs(distance) < 20 && !options.forceAnimate && !options.sectionTransition) {
        scrollWindowTo(targetY);
        updatePinnedStages(targetY);
        blanketAnimating = false;
        return Promise.resolve();
      }

      blanketAnimating = true;
      previousScrollBehavior = rootElement.style.scrollBehavior;
      rootElement.style.scrollBehavior = 'auto';
      document.body.style.scrollSnapType = 'none';
      document.documentElement.style.scrollSnapType = 'none';

      return new Promise(function (resolve) {
        function finishAnimation() {
          scrollWindowTo(targetY);
          updatePinnedStages(targetY);

          requestAnimationFrame(function () {
            if (isMobile()) {
              document.documentElement.style.scrollSnapType = 'y mandatory';
            } else {
              document.body.style.scrollSnapType = '';
            }

            rootElement.style.scrollBehavior = previousScrollBehavior;
            blanketAnimating = false;
            resolve();
          });
        }

        function step(timestamp) {
          if (!startTime) startTime = timestamp;

          var elapsed = timestamp - startTime;
          var progress = Math.min(elapsed / scrollDuration, 1);
          var currentY = startY + distance * easing(progress);

          scrollWindowTo(currentY);
          updatePinnedStages(currentY);

          if (progress < 1) {
            requestAnimationFrame(step);
            return;
          }

          finishAnimation();
        }

        requestAnimationFrame(step);
      });
    };

    function goToSection(index) {
      if (isScrollLocked()) return Promise.resolve();
      if (index < 0 || index >= snapSections.length) return Promise.resolve();
      if (index === currentSectionIndex) return Promise.resolve();

      blanketAnimating = true;
      currentSectionIndex = index;
      homepageScroll.setCurrentSectionIndex(index);

      return animateBlanketScrollTo(homepageScroll.getSnapTop(index), {
        sectionTransition: true,
        duration: prefersReducedMotion.matches ? 0 : transitionMs,
        forceAnimate: true
      });
    }

    function handleScrollIntent(direction) {
      if (isScrollLocked()) return;

      if (direction > 0 && currentSectionIndex < snapSections.length - 1) {
        goToSection(currentSectionIndex + 1);
        return;
      }

      if (direction < 0 && currentSectionIndex > 0) {
        goToSection(currentSectionIndex - 1);
      }
    }

    function onWheel(event) {
      if (event.deltaY === 0) return;
      if (
        document.body.classList.contains('menu-open') ||
        document.body.classList.contains('search-open')
      ) {
        return;
      }

      var direction = event.deltaY > 0 ? 1 : -1;
      var canMove =
        (direction > 0 && currentSectionIndex < snapSections.length - 1) ||
        (direction < 0 && currentSectionIndex > 0);

      if (!canMove) return;

      event.preventDefault();

      if (!shouldNavigateOnWheel(event)) return;

      gestureNavUsed = true;
      handleScrollIntent(direction);
    }

    var touchStartY = null;
    var touchStartX = null;

    function onTouchStart(event) {
      if (event.touches.length !== 1) return;

      touchStartY = event.touches[0].clientY;
      touchStartX = event.touches[0].clientX;
    }

    function onTouchMove(event) {
      if (touchStartY == null || isScrollLocked()) return;

      var deltaY = touchStartY - event.touches[0].clientY;
      var deltaX = touchStartX - event.touches[0].clientX;

      if (Math.abs(deltaY) <= Math.abs(deltaX)) return;

      event.preventDefault();
    }

    function onTouchEnd(event) {
      if (touchStartY == null || isScrollLocked()) return;

      var touch = event.changedTouches[0];
      var deltaY = touchStartY - touch.clientY;
      var deltaX = touchStartX - touch.clientX;

      touchStartY = null;
      touchStartX = null;

      if (Math.abs(deltaY) <= Math.abs(deltaX)) return;

      gestureNavUsed = true;
      handleScrollIntent(deltaY > 0 ? 1 : -1);
    }

    currentSectionIndex = homepageScroll.getNearestSnapIndex(getScrollY());
    homepageScroll.setCurrentSectionIndex(currentSectionIndex);
    snapToCurrentSection();

    window.addEventListener('wheel', onWheel, { passive: false });
    window.addEventListener('touchstart', onTouchStart, { passive: true });
    window.addEventListener('touchmove', onTouchMove, { passive: false });
    window.addEventListener('touchend', onTouchEnd, { passive: true });

    window.addEventListener('resize', function () {
      if (blanketAnimating) return;
      snapToCurrentSection();
    });
  }

  function normalizeTranslateY(value) {
    return value <= 2 ? 0 : value;
  }

  function initHomepageScrollOrigin() {
    if (!document.body.classList.contains('template-index')) return;

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    function scrollToHero() {
      currentSectionIndex = 0;

      if (homepageScroll) {
        homepageScroll.setCurrentSectionIndex(0);
      }

      window.scrollTo(0, 0);
      updatePinnedStages(0);
    }

    scrollToHero();

    window.addEventListener('load', scrollToHero);
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        scrollToHero();
      }
    });
  }

  function initMobileScrollSettle() {
    if (!document.body.classList.contains('template-index')) return;
    if (!homepageScroll || prefersReducedMotion.matches) return;

    function reconcileScrollPosition() {
      if (
        blanketAnimating ||
        document.body.classList.contains('menu-open') ||
        document.body.classList.contains('search-open')
      ) {
        return;
      }

      var expectedY = homepageScroll.getSnapTop(currentSectionIndex);
      var drift = Math.abs(getScrollY() - expectedY);

      if (drift < getSectionHeight() * 0.04) return;

      if (animateBlanketScrollTo) {
        animateBlanketScrollTo(expectedY, {
          sectionTransition: true,
          duration: 0,
          forceAnimate: true
        });
        return;
      }

      window.scrollTo(0, expectedY);
      updatePinnedStages(expectedY);
    }

    if ('onscrollend' in window) {
      window.addEventListener('scrollend', reconcileScrollPosition, { passive: true });
    }
  }

  function initThemeEditorHomepageResync() {
    if (!window.Shopify || !Shopify.designMode) return;
    if (!homepageScroll || typeof homepageScroll.resync !== 'function') return;

    var resyncTimer = null;

    function scheduleResync() {
      if (resyncTimer) window.clearTimeout(resyncTimer);

      resyncTimer = window.setTimeout(function () {
        resyncTimer = null;
        homepageScroll.resync();
      }, 50);
    }

    document.addEventListener('shopify:section:load', scheduleResync);
    document.addEventListener('shopify:section:unload', scheduleResync);
    document.addEventListener('shopify:section:reorder', scheduleResync);
  }

  function initPinnedStages() {
    if (!document.body.classList.contains('template-index')) return;

    homepageScroll = createHomepageScroll();

    var featuredSections = homepageScroll.featuredSections;
    var footer = homepageScroll.footer;

    homepageScroll.applyFeaturedMeta();

    if (!document.querySelector('.blanket-scroll-backdrop')) {
      var backdrop = document.createElement('div');
      backdrop.className = 'blanket-scroll-backdrop';
      backdrop.setAttribute('aria-hidden', 'true');
      document.body.insertBefore(backdrop, document.body.firstChild);
    }

    updatePinnedStages = function (scrollY) {
      var resolvedScrollY = typeof scrollY === 'number' ? scrollY : getScrollY();

      featuredSections.forEach(function (section, index) {
        var stage = section.querySelector('.featured-collection__stage');
        if (!stage) return;

        var offset = homepageScroll.getSnapTop(index + 1);
        var translateY = normalizeTranslateY(Math.max(0, offset - resolvedScrollY));
        stage.style.transform = 'translate3d(0, ' + translateY + 'px, 0)';
      });

      if (footer.section && footer.stage) {
        var footerOffset = homepageScroll.getFooterBlanketOffset();
        var footerTranslateY = normalizeTranslateY(
          Math.max(0, footerOffset - resolvedScrollY)
        );
        footer.stage.style.transform = 'translate3d(0, ' + footerTranslateY + 'px, 0)';
      }
    };

    function blanketRenderLoop() {
      updatePinnedStages();
      requestAnimationFrame(blanketRenderLoop);
    }

    requestAnimationFrame(blanketRenderLoop);

    window.addEventListener('resize', homepageScroll.refreshLayout);
    window.addEventListener('orientationchange', homepageScroll.refreshLayout);
    window.addEventListener('load', homepageScroll.refreshLayout);

    prefersReducedMotion.addEventListener('change', homepageScroll.refreshLayout);

    homepageScroll.refreshLayout();
    initThemeEditorHomepageResync();
  }
})();
